import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import HomePage from './components/HomePage';
import CompanyDetail from './components/CompanyDetail';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Helmet>
          <title>CM Groups - Premium Builders & Construction | Engineering Your Dreams Since 1995</title>
          <meta 
            name="description" 
            content="CM Groups - Trusted builders and construction company in Chennai. 25+ years of excellence in residential, commercial construction, architecture, and real estate. Quality materials, on-time delivery, proven track record." 
          />
          <meta name="keywords" content="builders Chennai, construction company, real estate developers, architecture, construction services, CM Groups" />
          <meta property="og:title" content="CM Groups - Premium Builders & Construction" />
          <meta property="og:description" content="Building Excellence Since 1995. Trust, Quality, and Timely Delivery." />
          <meta property="og:type" content="website" />
          <link rel="canonical" href="https://cmgroups.in" />
        </Helmet>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/company/:id" element={<CompanyDetail />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

